import CalendarEvent from 'mini-calendar-event-types/lib/MiniCalendarEvent';
import DayViewItem from 'mini-day-view/lib/schema/DayViewItem';
import { AllDayItem } from 'mini-calendar-day-surface';
import { createStore } from 'satcheljs';
import { DayViewStore } from './schema/DayViewStore';
import { ObservableMap } from 'mobx';

const initDayViewStoreData: DayViewStore = {
    dayViewInDayItemsMap: new ObservableMap<string, DayViewItem<CalendarEvent>[]>(),
    dayViewAllDayItemsMap: new ObservableMap<string, AllDayItem[]>(),
};

export const getDayViewStore = createStore<DayViewStore>('DayViewStore', initDayViewStoreData);

export const dayViewStore = getDayViewStore();
export default getDayViewStore;
